import React, { useEffect, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { SplashScreen } from './components/SplashScreen';
import { Dashboard } from './components/Dashboard';
import { EnergyPopup } from './components/EnergyPopup';
import { EmotionScanner } from './components/EmotionScanner';
import { Boutique } from './components/Boutique';
import { ProfileSettings } from './components/ProfileSettings';
import { DailyRitual } from './components/ritual/DailyRitual';
import { THERAPY_MATRIX, TherapyConfig } from './components/EmotionScanner';
import { SoundCatalog } from './components/SoundCatalog';
import { BeliefDetox } from './components/BeliefDetox';
import { Affirmations } from './components/Affirmations';
import { ChakraCleansing } from './components/ChakraCleansing';
import { DeepSleep } from './components/DeepSleep';
import { LoginScreen } from './components/LoginScreen';
import { SomaticTracking } from './components/SomaticTracking';
import { LandingPage } from './components/LandingPage';
type ViewState = 'splash' | 'dashboard' | 'scanner' | 'boutique' | 'profile' | 'ritual' | 'soundCatalog' | 'beliefDetox' | 'affirmations' | 'chakraCleansing' | 'deepSleep' | 'somaticTracking' | 'login' | 'landingPage';
export function App() {
  const [view, setView] = useState<ViewState>('landingPage');
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [energyPoints, setEnergyPoints] = useState(150);
  const [activeTherapy, setActiveTherapy] = useState<TherapyConfig | undefined>(undefined);
  useEffect(() => {
    document.title = 'AuraSync — Twoja codzienna harmonia';
  }, []);
  const handleGoHome = () => {
    setView('splash');
    setIsPopupOpen(false);
  };
  const handleDeductPoints = (amount: number) => {
    setEnergyPoints(prev => Math.max(0, prev - amount));
  };
  const handleAddPoints = (amount: number) => {
    setEnergyPoints(prev => prev + amount);
  };
  return <div className="min-h-screen w-full bg-zen-bg font-sans text-zen-text flex justify-center overflow-x-hidden" data-id="element-0">
      <AnimatePresence mode="wait" data-id="element-1">
        {view === 'splash' && <SplashScreen key="splash" onComplete={destination => {
        if (destination === 'ritual') {
          setView('scanner');
        } else {
          setView('dashboard');
        }
      }} onOpenLogin={() => setView('login')} data-id="element-2" />}

        {view === 'login' && <LoginScreen key="login" onClose={() => setView('splash')} onLoginSuccess={() => setView('dashboard')} data-id="element-3" />}

        {view === 'dashboard' && <Dashboard key="dashboard" energyPoints={energyPoints} onOpenEnergyPopup={() => setIsPopupOpen(true)} onOpenScanner={() => setView('scanner')} onOpenBoutique={() => setView('boutique')} onOpenProfile={() => setView('profile')} onOpenSoundCatalog={() => setView('soundCatalog')} onOpenBeliefDetox={() => setView('beliefDetox')} onOpenAffirmations={() => setView('affirmations')} onOpenChakraCleansing={() => setView('chakraCleansing')} onOpenDeepSleep={() => setView('deepSleep')} onOpenSomaticTracking={() => setView('somaticTracking')} onOpenLandingPage={() => setView('landingPage')} onGoHome={handleGoHome} data-id="element-4" />}

        {view === 'scanner' && <EmotionScanner key="scanner" energyPoints={energyPoints} onDeductPoints={handleDeductPoints} onOpenEnergyPopup={() => setIsPopupOpen(true)} onClose={() => setView('dashboard')} onGoHome={() => setView('ritual')} onStartRitual={statusCategory => {
        const therapy = THERAPY_MATRIX[statusCategory] || THERAPY_MATRIX.STRESS;
        setActiveTherapy(therapy);
        setView('ritual');
      }} data-id="element-5" />}

        {view === 'ritual' && <DailyRitual key="ritual" onClose={() => {
        setView('dashboard');
        setActiveTherapy(undefined);
      }} therapyConfig={activeTherapy} onComplete={points => {
        handleAddPoints(points);
        setActiveTherapy(undefined);
        setView('dashboard');
      }} data-id="element-6" />}

        {view === 'soundCatalog' && <SoundCatalog key="soundCatalog" energyPoints={energyPoints} onDeductPoints={handleDeductPoints} onClose={() => setView('dashboard')} onGoHome={handleGoHome} data-id="element-7" />}

        {view === 'beliefDetox' && <BeliefDetox key="beliefDetox" energyPoints={energyPoints} onDeductPoints={handleDeductPoints} onClose={() => setView('dashboard')} data-id="element-8" />}

        {view === 'affirmations' && <Affirmations key="affirmations" onClose={() => setView('dashboard')} onComplete={points => {
        handleAddPoints(points);
        setView('dashboard');
      }} data-id="element-9" />}

        {view === 'chakraCleansing' && <ChakraCleansing key="chakraCleansing" onClose={() => setView('dashboard')} onComplete={points => {
        handleAddPoints(points);
        setView('dashboard');
      }} data-id="element-10" />}

        {view === 'deepSleep' && <DeepSleep key="deepSleep" onClose={() => setView('dashboard')} data-id="element-11" />}

        {view === 'somaticTracking' && <SomaticTracking key="somaticTracking" isStandalone={true} onClose={() => setView('dashboard')} onComplete={() => setView('dashboard')} data-id="element-12" />}

        {view === 'boutique' && <Boutique key="boutique" onClose={() => setView('dashboard')} onGoHome={handleGoHome} data-id="element-13" />}

        {view === 'profile' && <ProfileSettings key="profile" energyPoints={energyPoints} onClose={() => setView('dashboard')} onGoHome={handleGoHome} data-id="element-14" />}

        {view === 'landingPage' && <LandingPage key="landingPage" onClose={() => setView('dashboard')} onOpenApp={() => setView('dashboard')} data-id="element-15" />}
      </AnimatePresence>

      <AnimatePresence data-id="element-16">
        {isPopupOpen && <EnergyPopup onClose={() => setIsPopupOpen(false)} onOpenBoutique={() => {
        setIsPopupOpen(false);
        setView('boutique');
      }} data-id="element-17" />}
      </AnimatePresence>
    </div>;
}